let unloading = false;
window.addEventListener('beforeunload', () => { unloading = true });

export const isUnloading = (): boolean => unloading;
